import type { MessageSchema } from '@/translations';

const messages: MessageSchema = {
	a_few_more_details: 'Encore quelques détails',
	accept_mailinglist_sentence:
		'Oui, je souhaite être le premier informé des offres et des nouvelles de Thermen {resort}',
	accept_retreats_mailinglist_sentence:
		"Je m'inscris aux mailings de Retreats pour recevoir des nouvelles et des offres personnalisées",
	accept_terms_sentence: 'Par la présente, je confirme accepter les conditions suivantes : {terms_list}',
	accept_thermenfans_sentence:
		"Je m'inscris au {link} et bénéficie ainsi d'avantages exclusifs tels que : offres, bons de réduction personnalisés, cadeaux sympas et accès exclusif aux événements",
	add_one: 'Ajouter',
	all_choices: 'Tous les choix',
	amount_of_rooms: '{n} chambre | {n} chambres',
	an_email_will_be_sent_to_your_email_if_you_press_reset_password_this_email_will_contain_a_link_to_request_a_new_password:
		'Un e-mail sera envoyé à votre adresse e-mail si vous appuyez sur réinitialiser le mot de passe. Cet e-mail contiendra un lien pour demander un nouveau mot de passe',
	are_you_coming_together_but_still_want_to_enjoy_your_own_room:
		"Vous venez ensemble, mais vous souhaitez tout de même profiter d'une chambre privée ? Pas de problème. Indiquez simplement votre préférence lors de la réservation, et nous nous assurerons que tout est organisé selon vos souhaits. Ainsi, chacun pourra vivre son moment ultime de détente.",
	are_you_sure_you_want_to_reset_your_password: 'Êtes-vous sûr de vouloir réinitialiser votre mot de passe ?',
	arrangement_badge: 'Forfait',
	arrangement_choice_nr: "Choix d'arrangement {n}",
	arrangement_choices: 'Arrangement @:choices',
	arrival: 'Arrivée',
	arrival_badge: 'arrivée',
	arrival_night_subtitle: 'Tous les avantages de votre forfait',
	arrival_or_departure_day: "Jour d'arrivée/de départ",
	arrival_and_departure_time_explanation:
		"Pour une visite agréable, nous vous demandons d'arriver et de partir aux horaires de votre réservation. De cette façon, nous maintenons ensemble un bon équilibre dans le nombre de clients qui effectuent leur check-in et check-out.",
	choose_arrival_and_departure_time: "Choisissez votre heure d'arrivée et de départ prévue",
	belgium: 'Belgique',
	business_name: "Nom de l'entreprise",
	cancellation_policy: "Conditions d'annulation",
	cancellation_guarantee_title: "Garantie d'annulation",
	cancellation_guarantee_description:
		"Évitez des frais inutiles et ajoutez une garantie d'annulation flexible pour seulement {price} par personne.",
	cancellation_guarantee_checkbox_label:
		"Oui, je souhaite souscrire une garantie d'annulation pour {price} par personne",
	cancellation_guarantee_subtitle:
		"Avec cette garantie, vous pouvez annuler ou reporter votre réservation gratuitement jusqu'à 10h00 le jour de l'arrivée.",
	cancellation_guarantee_benefit_deadline: "Annulez ou reportez gratuitement jusqu'à 10h00 le jour de l'arrivée.",
	cancellation_guarantee_benefit_reschedule:
		"Un report vers une autre date est possible. Le cas échéant, un supplément s'applique pour la différence de prix.",
	cancellation_guarantee_benefit_any_reason:
		"Vous pouvez annuler ou reporter votre séjour, quelle qu'en soit la raison.",
	cancellation_guarantee_online_only: "Cette garantie peut uniquement être ajoutée lors d'une réservation en ligne.",
	change_value_of_type_to_number: 'Modifiez la valeur de {type} en {number}',
	choices: 'choix | choix',
	choose_arrangement:
		'Faites-en vraiment votre arrangement. Choisissez votre favori parmi les options ci-dessous pour votre journée bien-être.',
	choose_your_arrival_and_departure_day_in_the_calendar:
		"Choisissez dans le calendrier votre jour d'arrivée et de départ",
	city: 'Ville',
	close: 'Fermer',
	comments_or_extra_information: 'Commentaires / informations supplémentaires',
	continue_reservation: 'Continuer',
	country: 'Pays',
	customer_page_into_sentence:
		"Nous avons besoin d'un peu plus d'informations de votre part. Juste un peu. Et bien sûr, nous gardons vos données pour nous. Promis.",
	date_of_birth: 'Date de naissance',
	day: 'Jour',
	departure: 'Départ',
	departure_badge: 'départ',
	departure_day_subtitle: 'Incl. petit-déjeuner et accès aux thermes',
	edit: 'Modifier',
	email_address: 'Adresse e-mail',
	estimated_time_of_arrival: "Heure d'arrivée",
	estimated_time_of_departure: 'Heure de départ',
	finish_it_or_start_over: 'Souhaitez-vous la terminer ou en commencer une nouvelle ?',
	finish_reservation: 'Terminer la réservation',
	new_reservation: 'Nouvelle réservation',
	retreat_program_times:
		"Vous êtes les bienvenus à partir de {start_time} le {arrival_date}. Le programme se termine vers {end_time} le {departure_date}, après quoi vous êtes les bienvenus dans l'espace wellness.",
	evening: 'Soir',
	extra_charge: 'Supplément',
	extra_night_breakdown_title: 'Détail du prix',
	extra_night_info_text:
		'Lors de votre arrivée, vous apprenez quand vos activités (par exemple un soin ou un dîner) sont prévues. Elles ont généralement lieu le jour de votre arrivée et/ou le deuxième jour.\n\nVous restez plusieurs nuits ? Vous bénéficiez alors d’un tarif particulièrement avantageux par nuit.',
	extra_night_subtitle: 'Incl. petit-déjeuner et accès aux thermes',
	filter: 'filtrer',
	first_name: 'Prénom',
	fold: 'Replier',
	for_who: 'Pour qui ?',
	forgot_your_password_no_problem: 'Mot de passe oublié ? Pas de problème.',
	from_price: 'à p. de',
	germany: 'Allemagne',
	go_to_the_website: 'Aller sur le site web',
	hide: 'Masquer les',
	hide_all_single_rooms: 'Masquer toutes les chambres simples',
	hotel_room_availability: 'Encore {number} disponible',
	hotel_room_choice: "Choisissez votre chambre d'hôtel",
	hotel_room_type_1: 'CHAMBRE SIMPLE',
	hotel_room_type_2: 'CHAMBRE DOUBLE',
	hotel_room_type_3: 'CHAMBRE TRIPLE',
	hotel_room_type_4: 'CHAMBRE QUADRUPLE',
	view_details: 'Voir les détails',
	hide_details: 'Masquer les détails',
	select_room: 'CHOISIR CHAMBRE',
	select_this_room: 'CHOISIR CETTE CHAMBRE',
	choose_your_hotel_room: 'Choisissez votre chambre',
	what_this_room_offers: 'CE QUE CETTE CHAMBRE OFFRE',
	all: 'Tous',
	change: 'Modifier',
	booking_summary:
		"Vous souhaitez réserver pour {persons} et vous voulez {rooms} avec date d'arrivée {arrival} et date de départ {departure}.",
	room: 'chambre',
	rooms: 'chambres',
	hotel_rooms: "Chambres d'hôtel",
	hotel_rooms_page_into_sentence: 'Vous venez passer la nuit chez nous ?',
	house_number: 'Numéro de maison',
	house_number_addition: 'Ajout',
	house_rules: 'règlement intérieur',
	make_your_choice: 'Faites votre choix',
	duration: 'Durée',
	how_would_you_like_to_book_your_relaxing_moment: 'Comment souhaitez-vous réserver votre moment de détente ?',
	i_have_a_my_thermen_account: "J'ai un compte Thermen Resorts",
	i_want_to_create_a_my_thermen_account: 'Je souhaite créer un compte Thermen Resorts',
	i_want_to_create_a_my_thermen_account_tooltip:
		"Réservez plus rapidement et ne saisissez plus jamais vos données. Un compte Thermen Resorts vous offre plus. Plus de commodité et plus d'avantages. Attention ! Votre compte n'est activé qu'en cliquant sur le lien dans l'e-mail de vérification.",
	i_want_to_make_a_reservation_without_an_account: 'Je veux réserver sans compte',
	i_would_like_to_create_an_account: 'Je souhaite créer un compte',
	invoice_comment_placeholder: "Commentaires/détails (par exemple numéro d'achat)",
	invoice_information: 'Détails de la facture employeur',
	last_name: 'Nom de famille',
	login: 'Connexion',
	logout: 'Déconnexion',
	lunch_and_diner: 'Déjeuner et dîner',
	lunch_and_diner_page_into_sentence:
		'Votre journée bien-être encore plus complète et encore plus agréable ? Découvrez nos séances de versement, rituels, méditations et autres moments de détente agréables... Notre conseil ? Choisissez surtout ce qui vous rend heureux !',
	make_it_your_day: 'Faites-en votre journée !',
	mobile_phone_number: 'Numéro de téléphone portable',
	month: 'Mois',
	more_info: "Plus d'info",
	more_information: "Plus d'informations",
	morning: 'Matin',
	mr: 'M.',
	ms: 'Mme',
	my_preferences_for_a_room_are: 'Mes préférences pour une chambre sont',
	navigate_to_name_in_the_calendar: 'Accédez à {name} dans le calendrier.',
	name_infix: 'Particule',
	need_help_with_your_room_choices: "Besoin d'aide pour choisir votre chambre ?",
	next: 'Suivant',
	nights_count: '{n} nuit | {n} nuits',
	nth_night: '{n}e nuit',
	no_rooms_available_selected_date_filters:
		"Pour la date actuellement sélectionnée, en combinaison avec les filtres sélectionnés, aucune chambre n'est disponible.",
	notice_chosen_date_or_time_is_unavailable: "La date et/ou l'heure choisies ne sont pas disponibles !",
	notice_there_are_no_hotel_rooms_unavailable:
		'Aucune chambre disponible à la date choisie avec les filtres sélectionnés.',
	notice_this_hotel_room_is_unavailable: "Cette chambre n'est plus disponible pour le jour choisi !",
	number_of_persons: '{n} personne | {n} personnes',
	or_stay_with_us_for_a_good_night_sleep: 'Ou restez-vous dormir agréablement ?',
	other: 'Autre',
	one_or_more_choices_are_no_longer_available:
		'Un ou plusieurs choix de votre réservation ne sont plus disponibles. Modifiez-les pour continuer.',
	password: 'Mot de passe',
	password_confirmation: 'Confirmer le mot de passe',
	pay: 'Payer',
	per_night: 'par nuit',
	per_person_including_breakfast_starting_from: 'p.p. incluant le petit-déjeuner à partir de',
	per_person_per_night: 'p.p.p.n.',
	per_person_short: 'p.p.',
	persons: 'personne | personnes',
	persons_count: 'Nombre de personnes',
	persons_short: 'pers.',
	price_included: 'Inclus',
	previous: 'Précédent',
	prices_are_in_euro: 'Les prix sont en € @:per_person_short',
	prices_are_in_euro_per_night: 'Les prix sont en € @:per_person_per_night',
	privacy_policy: 'Politique de confidentialité',
	receive_a_present_on_your_birthday: 'Recevoir un cadeau pour votre anniversaire ?',
	reload: 'Recharger',
	request_your_new_password_here: 'Demandez votre nouveau mot de passe ici.',
	read_only_availability_notice:
		"Il s'agit d'un environnement fictif pour consulter les disponibilités. Achetez d'abord votre ticket, puis effectuez votre réservation définitive via notre site web.",
	reset: 'Réinitialiser',
	reset_filters: 'Réinitialiser les filtres',
	reset_password: 'Réinitialiser le mot de passe',
	rituals_extras: 'Extras pour votre journée au sauna',
	rituals_extras_page_into_sentence:
		'Votre journée bien-être encore plus complète et encore plus agréable ? Découvrez nos séances de versement, rituels, méditations et autres moments de détente agréables... Notre conseil ? Choisissez surtout ce qui vous rend heureux !',
	rooms_count: 'Nombre de chambres',
	select: 'Sélectionner',
	skip_this_step: 'Passer cette étape',
	select_all: 'Sélectionner tout',
	select_for_all: 'Sélectionner pour tout le monde',
	selected: 'Sélectionné',
	send_invoice: 'Mon employeur paie la facture.',
	share_a_room_together_select_one_of_the_available_room_options_below:
		"Partagez une chambre ensemble, sélectionnez l'une des options de chambre disponibles ci-dessous.",
	show_all_single_rooms: 'Afficher toutes les chambres simples',
	something_went_wrong_while_retrieving_your_data: 'Un problème est survenu lors de la récupération de vos données.',
	start_a_new_reservation: 'Recommencer',
	steps: {
		choices: 'Vos choix',
		complete: 'Terminer',
		customer_details: 'Détails du client',
		reservation: 'Réservation',
	},
	street: 'Rue',
	swimwear_day: 'Jour de maillot de bain',
	filter_swimwear_days: 'Filtrer sur les jours de maillot de bain',
	swimwear_day_tooltip_sentence:
		'Les jours marqués en bleu dans le calendrier sont des jours de maillot de bain. Le port du maillot de bain est obligatoire ces jours-là.',
	special_day: 'Jour spécial',
	terms_and_conditions: 'Conditions générales',
	terms_item_1:
		"Mon heure d'arrivée et de départ (afin que les éventuels traitements puissent avoir lieu dans la demi-heure suivant l'heure d'arrivée indiquée et avant l'heure de départ indiquée)",
	terms_item_2: "J'ai lu le {house_rules}",
	terms_item_3: 'Les {terms_and_conditions}, les {cancellation_policy} et la {privacy_policy}',
	the_netherlands: 'Pays-Bas',
	the_price_of_your_reservation_has_changed:
		'Attention : le prix de votre réservation a changé. Avant {previous}, maintenant {current}.',
	there_are_no_selectable_products_available_at_the_selected_time:
		'Aucune option n’est disponible pour la date choisie. Veuillez essayer un autre moment.',
	thermenfans_program: 'Programme Thermenfans',
	total: 'Total',
	treatment_page_into_sentence:
		"Votre journée chez nous peut être encore plus complète. Un massage ? Un traitement ? Notre conseil : choisissez ce qui vous rend heureux, c'est toujours le meilleur choix.",
	unavailable: 'Indisponible',
	unfortunately_an_error_has_occurred_please_try_again_shortly:
		'Malheureusement, une erreur s’est produite. Veuillez réessayer dans un instant.',
	unfortunately_there_are_no_available_choices_on_this_date_please_select_another_date:
		"Malheureusement, il n'y a pas de choix disponibles à cette date, veuillez sélectionner une autre date",
	plan_your: 'Planifiez votre {product}',
	view: 'Voir la',
	view_reservation: 'Voir votre réservation ici',
	we_put_together_the_available_options_for_you: 'Nous rassemblons les options disponibles pour vous...',
	what_would_you_like_to_book: 'Que souhaitez-vous réserver ?',
	when_are_you_coming_to_relax: 'Quand viendrez-vous vous détendre ?',
	when_resetting_previously_entered_data_will_be_lost:
		'En réinitialisant, les données saisies précédemment seront perdues.',
	which_type_of_treatment_suits_you: 'Quel type de traitement vous convient ?',
	year: 'Année',
	you_have: 'Vous avez',
	you_have_an_unfinished_reservation: 'Vous avez une réservation inachevée',
	you_have_number_of_choices: 'Vous avez <strong>{n}</strong> @:choices',
	you_want_to_book_with:
		"Vous voulez réserver avec <strong>{persons}</strong> et souhaitez <strong>{rooms}</strong> avec une date d'arrivée {arrival_date} et une date de départ {departure_date}.",
	your_experience: 'Voici ce que vous allez vivre :',
	your_first_step_to_great_enjoyment: 'Votre premier pas vers un grand plaisir !',
	your_reservation_has_changed: 'Votre réservation a changé',
	zip_code: 'Code postal',
};

export default messages;
